import { projectDataType } from ".";

const conductivityResistivityData: projectDataType = {
  path: "conductivityresistivity",
  title: "Conductivity Resistivity",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684452591/conductivity-resistivity/ConductivityResistivity.png",
  description: "A 3D Art Museum featuring 3D art, right in your broswer.",
  year: 2013,
  link: "https://conductivityresistivity.art",
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964412/Art-Site/the-wrong/stills/lobby.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964406/Art-Site/the-wrong/stills/rachel-archibald-1.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964412/Art-Site/the-wrong/stills/ferran-pla.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964409/Art-Site/the-wrong/stills/anthi-tzakou.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964408/Art-Site/the-wrong/stills/anthi-tzakou-2.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964411/Art-Site/the-wrong/stills/angelo-plessas.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964408/Art-Site/the-wrong/stills/seyhan-2.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964411/Art-Site/the-wrong/stills/seyhan-1.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964411/Art-Site/the-wrong/stills/maiko-gubler.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964406/Art-Site/the-wrong/stills/vince-mckelvie.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964406/Art-Site/the-wrong/stills/vince-mckelvie-2.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964407/Art-Site/the-wrong/stills/Katja-Novitskova.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964411/Art-Site/the-wrong/stills/museum-outside.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964410/Art-Site/the-wrong/stills/museum-outside-2.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964409/Art-Site/the-wrong/stills/museum-outside-3.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964409/Art-Site/the-wrong/stills/museum-outside-4.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964408/Art-Site/the-wrong/stills/projectBanner.jpg",
  ],
  invitations: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964412/Art-Site/the-wrong/stills/con-res-invite.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964411/Art-Site/the-wrong/stills/wrong-istanbul-skin-v4_ilq5qt.jpg",
  ],
};

export default conductivityResistivityData;
